import { useState } from "react";
import { useSWRConfig } from "swr";
import useSWRInfinite from "swr/infinite";
export default function (getKey, options, limit) {
    var _a, _b, _c;
    const { mutate: globalMutate } = useSWRConfig();
    const [keys, setKeys] = useState([]);
    const response = useSWRInfinite((pageIndex, previousPageData) => {
        const params = getKey(pageIndex, previousPageData);
        const key = params && params[0] ? params[0] : null;
        if (key && !keys.includes(key)) {
            setKeys([...keys, key]);
        }
        return params;
    }, null, options);
    const { size, error, setSize, mutate } = response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = response.data;
    let hasNextPage;
    if (limit !== undefined) {
        hasNextPage =
            size === 0 || Boolean(((_b = (_a = data === null || data === void 0 ? void 0 : data[size - 1]) === null || _a === void 0 ? void 0 : _a.collections) === null || _b === void 0 ? void 0 : _b.length) === limit);
    }
    else {
        hasNextPage = size === 0 || Boolean((_c = data === null || data === void 0 ? void 0 : data[size - 1]) === null || _c === void 0 ? void 0 : _c.continuation);
    }
    const isFetchingInitialData = !data && !error && size > 0;
    const isFetchingPage = size > 0 &&
        (isFetchingInitialData || (data && typeof data[size - 1] === "undefined"));
    const fetchNextPage = () => {
        if (!isFetchingPage && hasNextPage) {
            setSize((size) => size + 1);
        }
    };
    const resetCache = () => {
        setSize(0);
        return mutate(undefined, {
            revalidate: false,
        }).then(() => {
            globalMutate((key) => {
                const url = key && key[0] ? key[0] : null;
                if (url) {
                    return keys.includes(url);
                }
                return false;
            }, undefined, false).then(() => {
                setKeys([]);
            });
        });
    };
    return {
        ...response,
        hasNextPage,
        isFetchingInitialData,
        isFetchingPage,
        resetCache,
        fetchNextPage,
    };
}
